import type { FaireProductEntity } from "../../entity_types/product";

export const p_5n5bg4tj6p: FaireProductEntity = {
  token: "p_5n5bg4tj6p",
  type: "product",
  name: "Matches - Sardines",
  brandToken: "b_40e71bc7",
  brandName: "HomArt",
  imageUrl:
    "https://cdn.faire.com/fastly/f70bef71f6d21560ed3e0a06ec198066c6d8bfb32388e3a999914fe52c3d0a72.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8899564bb53e845c404cf43a73768a7bf20a96f221688916f41d7cdd9b1b0189.jpeg",
  ],
  priceDollars: 2.1,
  description:
    "A quintessential article of daily use, our Match Boxes flaunt unique designs with coordinating match tips. Sweet as a hostess gift, a perfect pairing to a candle and always an eye catching pop of graphic decor. Safety matches, 50 sticks per box.",
  tags: [],
  msrpDollars: 4.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:36:28.480Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
